import { Component, LOCALE_ID, OnInit, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { links } from '../../shared/links';
import { StandortRechnerComponent } from './standort/standort-rechner.component';
import { RECHNER_ROUTES } from './rechner-amortisation-page.component';

/**
 * SEO-Landingpage rund um den Standort-Rechner (parallel zum Standort-Guide).
 * Der interaktive Teil steckt in <app-standort-rechner>; hier drumherum nur Inhalt.
 */
@Component({
  selector: 'app-rechner-standort-page',
  standalone: true,
  imports: [RouterModule, StandortRechnerComponent],
  templateUrl: './rechner-standort-page.component.html',
  styleUrl: './rechner-standort-page.component.css',
})
export class RechnerStandortPageComponent implements OnInit {
  private readonly title = inject(Title);
  private readonly meta = inject(Meta);
  private readonly document = inject(DOCUMENT);
  private readonly locale = inject(LOCALE_ID);

  readonly links = links;
  readonly guideLocationPath = $localize`:@@routes.guide.item.location:standortguide`;
  readonly routeStandort = $localize`:@@routes.rechner.item.standort:standort`;

  ngOnInit(): void {
    this.title.setTitle(
      $localize`:@@standortPage.meta.title:Standort für Verkaufsautomaten prüfen – Score & Umsatz`,
    );
    this.meta.updateTag({
      name: 'description',
      content: $localize`:@@standortPage.meta.description:Lohnt sich Ihr Verkaufsautomat an diesem Standort? Score, realistischer Umsatzkorridor und Break-even – auf Basis von über 450 marktbox-Automaten.`,
    });
    this.meta.updateTag({
      property: 'og:title',
      content: $localize`:@@standortPage.meta.ogTitle:Lohnt sich Ihre marktbox an diesem Platz? Rechnen Sie es aus.`,
    });

    const canonical = this.canonicalUrl();
    this.meta.updateTag({ property: 'og:url', content: canonical });
    this.setCanonical(canonical);
  }

  /** In-Page-Anker – plain href="#id" scheitert an <base href="/">. */
  scrollToAnchor(event: Event, id: string): void {
    event.preventDefault();
    this.document.getElementById(id)?.scrollIntoView({
      behavior: 'auto',
      block: 'start',
      inline: 'nearest',
    });
  }

  private canonicalUrl(): string {
    const localePrefix = this.locale.startsWith('da') ? 'da' : this.locale.startsWith('nl') ? 'nl' : 'de';
    return `https://marktbox.de/${localePrefix}/${RECHNER_ROUTES.rechner}/${this.routeStandort}`;
  }

  private setCanonical(href: string): void {
    let link = this.document.querySelector<HTMLLinkElement>('link[rel=canonical]');
    if (!link) {
      link = this.document.createElement('link');
      link.rel = 'canonical';
      this.document.head.appendChild(link);
    }
    link.href = href;
  }
}
